<template>
  <v-card
    class="credits-card pa-4 d-flex flex-column ga-2"
    @click="$emit('open-dialog')"
  >
    <div class="d-flex align-center ga-4">
      <v-icon>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <mask
            id="mask0_8740_116213"
            style="mask-type: alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="24"
          >
            <rect width="24" height="24" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_8740_116213)">
            <path
              d="M12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM11 19.925V18.925C10.4167 18.8417 9.85417 18.6833 9.3125 18.45C8.77083 18.2167 8.26667 17.9333 7.8 17.6L7.1 18.325C7.65 18.7583 8.25417 19.1125 8.9125 19.3875C9.57083 19.6625 10.2667 19.8417 11 19.925ZM13 19.925C13.7333 19.8417 14.4292 19.6625 15.0875 19.3875C15.7458 19.1125 16.35 18.7583 16.9 18.325L16.2 17.6C15.7333 17.9333 15.2292 18.2167 14.6875 18.45C14.1458 18.6833 13.5833 18.8417 13 18.925V19.925ZM12 17C13.3833 17 14.5625 16.5125 15.5375 15.5375C16.5125 14.5625 17 13.3833 17 12C17 10.6167 16.5125 9.4375 15.5375 8.4625C14.5625 7.4875 13.3833 7 12 7C10.6167 7 9.4375 7.4875 8.4625 8.4625C7.4875 9.4375 7 10.6167 7 12C7 13.3833 7.4875 14.5625 8.4625 15.5375C9.4375 16.5125 10.6167 17 12 17ZM18.325 16.9C18.7583 16.35 19.1125 15.7458 19.3875 15.0875C19.6625 14.4292 19.8417 13.7333 19.925 13H18.925C18.8417 13.5833 18.6833 14.1458 18.45 14.6875C18.2167 15.2292 17.9333 15.7333 17.6 16.2L18.325 16.9ZM5.675 16.9L6.4 16.175C6.06667 15.7083 5.78333 15.2083 5.55 14.675C5.31667 14.1417 5.15833 13.5833 5.075 13H4.075C4.15833 13.7333 4.3375 14.4292 4.6125 15.0875C4.8875 15.7458 5.24167 16.35 5.675 16.9ZM4.075 11H5.075C5.15833 10.4167 5.31667 9.85833 5.55 9.325C5.78333 8.79167 6.06667 8.29167 6.4 7.825L5.675 7.1C5.24167 7.65 4.8875 8.25417 4.6125 8.9125C4.3375 9.57083 4.15833 10.2667 4.075 11ZM18.925 11H19.925C19.8417 10.2667 19.6583 9.57083 19.375 8.9125C19.0917 8.25417 18.7333 7.65 18.3 7.1L17.6 7.8C17.9333 8.26667 18.2167 8.77083 18.45 9.3125C18.6833 9.85417 18.8417 10.4167 18.925 11ZM7.825 6.4C8.29167 6.06667 8.79167 5.78333 9.325 5.55C9.85833 5.31667 10.4167 5.15833 11 5.075V4.075C10.2667 4.15833 9.57083 4.3375 8.9125 4.6125C8.25417 4.8875 7.65 5.24167 7.1 5.675L7.825 6.4ZM16.2 6.4L16.9 5.7C16.35 5.26667 15.7458 4.90833 15.0875 4.625C14.4292 4.34167 13.7333 4.15833 13 4.075V5.075C13.5833 5.15833 14.1458 5.31667 14.6875 5.55C15.2292 5.78333 15.7333 6.06667 16.2 6.4Z"
              fill="#4E4E4E"
            />
          </g>
        </svg>
      </v-icon>

      <span class="p text-bold">{{
        $i18n.locale == "nl" ? "Jouw credits" : "Your credits"
      }}</span>
    </div>

    <div class="d-flex flex-column ga-2">
      <div class="d-flex align-center justify-space-between">
        <p class="text-capitalize">{{ showCurrentPeriod }}</p>
        <p>{{ $t("gebruikt-creditsused-max", [creditsUsed, max]) }}</p>
      </div>

      <v-progress-linear
        class="rounded-sm"
        :max="max"
        :model-value="creditsUsed"
        color="var(--company-primary)"
      ></v-progress-linear>
    </div>
  </v-card>
</template>

<script>
import { useMainStore } from "../stores/store";
export default {
  data() {
    return {
      mainStore: useMainStore(),

      max: 0,
      period: null,
    };
  },

  mounted() {
    this.max = this.mainStore.companypage.settings.credits;
    this.period = this.mainStore.companypage.settings.period;
  },

  computed: {
    creditsUsed() {
      // Beside the Etalage nobody is logged in: the card shows the page's
      // allowance with nothing spent, as a new member sees it (ADR-0069).
      return this.mainStore.user.credits ?? 0;
    },
    showCurrentPeriod() {
      switch (this.period) {
        case "day":
          return this.getCurrentDay();
        case "week":
          return this.getCurrentWeek();
        case "month":
          return this.getCurrentMonth();
        case "year":
          return this.getCurrentYear();
        default:
          return "";
      }
    },
  },

  methods: {
    getCurrentDay() {
      return new Date().toLocaleDateString(this.$i18n.locale, {
        weekday: "long",
      });
    },

    getCurrentWeek() {
      const today = new Date();
      const weekNumber = this.getWeekNumber(today);
      return this.$t("week-weeknumber", [weekNumber]);
    },

    getCurrentMonth() {
      return new Date().toLocaleDateString(this.$i18n.locale, {
        month: "long",
      });
    },

    getCurrentYear() {
      return new Date().getFullYear().toString();
    },

    getWeekNumber(date) {
      const d = new Date(
        Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
      );
      const dayNum = d.getUTCDay() || 7;
      d.setUTCDate(d.getUTCDate() + 4 - dayNum);
      const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
      return Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
    },
  },
};
</script>
